import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Modal } from "antd";
import { EditOutlined } from "@ant-design/icons";
import moment from "moment";

import StringUtils from "../../../../../../util/StringUtils";
import { SceneInformationWrapper, InfoColumn, InfoGroup, InfoGroupContent, InfoGroupTitle, InfoItem, InfoLabel, InfoValue, SceneThumbnail, ViewDeviceLink } from "./SceneInformation.styled";
import SceneApi from "../../../../../../api/SceneApi";
import FileApi from "../../../../../../api/FileApi";
import { CreateSceneWizard } from "../../../create-scene-wizard/CreateSceneWizard";
import Api from "../../../../../../api/Api";
import SessionService from "../../../../../../services/session/SessionService";

interface SceneInformationProps {
    sceneView: any
}

export const SceneInformation: React.FC<SceneInformationProps> = (props)=> {
    // state
    let [sceneView, setSceneView] = useState(props.sceneView);
    let [openUpdateSceneInformationModal, setOpenUpdateSceneInformationModal] = useState(false);

    // api
    let navigate = useNavigate();
    let sceneApi = new SceneApi();

    // events
    let onEditSceneInformation = ()=> {
        setOpenUpdateSceneInformationModal(true);
    }

    let refreshSceneView = async ()=> {
        let newSceneView = (await sceneApi.getSceneViewById(sceneView.scene.id)).data.data;
        setSceneView(newSceneView);
    };

    // utils
    let formatDateTime = (timestamp: number | string)=> {
        timestamp = Number(timestamp);
        return moment(timestamp).format('YYYY/MM/DD HH:mm:ss');
    }

    // render
    return (
        <SceneInformationWrapper>
            <InfoGroup>
                <InfoGroupTitle>基础信息 <Button type='link' onClick={onEditSceneInformation}><EditOutlined />编辑</Button></InfoGroupTitle>
                <InfoGroupContent>
                    <InfoColumn>
                        <SceneThumbnail style={{
                            backgroundImage: `url(${Api.URL_PREFIX + StringUtils.emptyToDefault(sceneView.scene.thumbnail, 'default') + "?Authorization=" + SessionService.getInstance().getAuthoriazation()})`
                        }} />
                    </InfoColumn>

                    <InfoColumn>
                        <InfoItem>
                            <InfoLabel>场景名称</InfoLabel>
                            <InfoValue>{sceneView.scene.name}</InfoValue>
                        </InfoItem>
                        <InfoItem>
                            <InfoLabel>设备数量 </InfoLabel>
                            <InfoValue>{sceneView.scene.deviceCount}</InfoValue>
                        </InfoItem>
                        <InfoItem>
                            <InfoLabel>备注</InfoLabel>
                            <InfoValue>{StringUtils.emptyToSlash(sceneView.scene.remarks)}</InfoValue>
                        </InfoItem>
                    </InfoColumn>

                    <InfoColumn>
                        <InfoItem>
                            <InfoLabel>创建时间</InfoLabel>
                            <InfoValue>{formatDateTime(sceneView.scene.createdTime)}</InfoValue>
                        </InfoItem>
                        <InfoItem>
                            <InfoLabel>修改时间</InfoLabel>
                            <InfoValue>{formatDateTime(sceneView.scene.updatedTime)}</InfoValue>
                        </InfoItem>
                    </InfoColumn>
                </InfoGroupContent>
            </InfoGroup>

            <Modal open={openUpdateSceneInformationModal}
                onClose={() => setOpenUpdateSceneInformationModal(false)}
                destroyOnClose={true}
                footer={null}
                closable={false}
                width={1000}
                height={600}
            >
                <CreateSceneWizard 
                    onClose={() => setOpenUpdateSceneInformationModal(false)} 
                    onComplete={() => refreshSceneView()} 
                    scene={sceneView.scene}
                />
            </Modal>
        </SceneInformationWrapper>
    )
}

export default SceneInformation;
